import React, { useState } from 'react';
import styled from 'styled-components';
import { FaArrowUp } from 'react-icons/fa';

const Box = styled.div`
    position: fixed;
    bottom: 20px;
    right: 25px;
    width: 50px;
    height: 50px;
    background: #2B2B2B;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    /* box-shadow: 0.5rem 0.5rem black, -0.5rem -0.5rem #ccc; */
    box-shadow: 0px 0px 3px 3px rgba(66, 63, 62,0.30);
    -webkit-box-shadow: 0px 0px 3px 3px rgba(66, 63, 62,0.30);
    -moz-box-shadow: 0px 0px 3px 3px rgba(66, 63, 62,0.30);
    z-index: 999;
    transition: .4s;

    &:hover {
        transform: scale(1.2);
    transition: .4s;
    }
    @media screen and (max-width: 668px) {
        bottom: 15px;
        right: 20px;
    }

    &.active {
        display: none;
        transition: .4s;
    }
`;


const SlideUp = () => {
    const [upDisplay, setUpDisplay] = useState('active');

    const displayBox = () => {
        if(window.scrollY >= 650) {
            setUpDisplay('');
        }else {
            setUpDisplay('active');
        }
    }
    const boxUp = () => {
        window.scroll(0,0);
    }
    window.addEventListener('scroll', displayBox); 
    return (
        <Box className = {upDisplay} onClick={() => boxUp()}>
            <FaArrowUp 
                color = "#FEFBF3"
                size = "22px"
            />
        </Box>
    )
}

export default SlideUp
